import { motion } from 'framer-motion';

const GRADIENTS = {
  blue: 'bg-gradient-to-br from-[#4318FF] to-[#868CFF]',
  green: 'bg-gradient-to-br from-[#01B574] to-[#43E97B]',
  purple: 'bg-gradient-to-br from-[#7000FF] to-[#B266FF]',
  orange: 'bg-gradient-to-br from-[#FF9000] to-[#FFB74D]',
  pink: 'bg-gradient-to-br from-[#FF5C8A] to-[#FF9CB3]',
  teal: 'bg-gradient-to-br from-[#06B6D4] to-[#67E8F9]',
};

/**
 * Vibrant KPI gradient stat card matching the Dashboard's stat-card style.
 * Use these instead of bordered white stat cards.
 */
export function StatCard({ title, value, sub, icon: Icon, color = 'blue', index = 0, testId }) {
  const gradient = GRADIENTS[color] || GRADIENTS.blue;
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.06 }}
    >
      <div
        className={`relative overflow-hidden rounded-[20px] p-5 ${gradient} shadow-[0px_18px_40px_rgba(112,144,176,0.18)]`}
        data-testid={testId}
      >
        <div className="pointer-events-none absolute -right-10 -top-10 h-36 w-36 rounded-full bg-white/10 blur-2xl" />
        <div className="relative flex items-start gap-4">
          {Icon ? (
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white/20 backdrop-blur-sm">
              <Icon className="h-6 w-6 text-white" strokeWidth={2} />
            </div>
          ) : null}
          <div className="min-w-0">
            <p className="text-[13px] font-medium text-white/85">{title}</p>
            <p className="mt-0.5 truncate font-['Manrope'] text-[26px] font-extrabold leading-tight text-white">
              {value}
            </p>
          </div>
        </div>
        {sub ? <p className="relative mt-3 text-[13px] font-medium text-white/75">{sub}</p> : null}
      </div>
    </motion.div>
  );
}

export default StatCard;
